import { useGetAverageReviewsForApplicationQuery, useListReviewsQuery } from "@stepapp/core";
import { ReviewSortFields, SortDirection } from "@stepapp/core/apiTypes";
import { Block, IconButton, palette, spacing, useBreakpoints } from "@stepapp/ui";
import { StyleSheet } from "react-native";
import ReviewsList from "./ReviewsList";

const itemsToFetch = 6;

const filter = { rating: { gte: 1 } };
const sorting = {
  direction: SortDirection.Desc,
  field: ReviewSortFields.ReservationStartedAt,
};

const ReviewsFrameScreen = () => {
  const { height } = useBreakpoints();

  const { data: avgReviews } = useGetAverageReviewsForApplicationQuery();
  const { data, loading, refetch } = useListReviewsQuery({
    variables: {
      filter,
      paging: { first: itemsToFetch },
      sorting,
    },
  });

  const pagination = data?.reviews?.pageInfo;

  const handleFetchPrevious = () => {
    refetch({
      filter,
      paging: { last: itemsToFetch, before: pagination?.startCursor },
      sorting,
    });
  };

  const handleFetchNext = () => {
    refetch({
      filter,
      paging: { first: itemsToFetch, after: pagination?.endCursor },
      sorting,
    });
  };

  return (
    <Block style={{ flex: 1, height }}>
      <ReviewsList
        reviewItems={data?.reviews?.edges || []}
        loading={loading}
        avgAppReviews={avgReviews?.getAverageReviewsForApplication}
      />

      <Block row style={styles.iconsContainer}>
        <IconButton
          size={36}
          name="chevron-left"
          // style={styles.editContainer}
          iconSize={20}
          iconColor={palette.common.black}
          onPress={handleFetchPrevious}
          disabled={loading || !pagination?.hasPreviousPage}
        />
        <IconButton
          size={36}
          name="chevron-right"
          style={styles.iconRight}
          iconSize={20}
          iconColor={palette.common.black}
          onPress={handleFetchNext}
          disabled={loading || !pagination?.hasNextPage}
        />
      </Block>
    </Block>
  );
};

export default ReviewsFrameScreen;

const styles = StyleSheet.create({
  iconsContainer: {
    justifyContent: "flex-end",
  },
  iconRight: {
    marginLeft: spacing.unit,
  },
});
